import { render } from "./Home.vue?vue&type=template&id=50fb6c24&scoped=true"
const script = {}

import "./Home.vue?vue&type=style&index=0&id=50fb6c24&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-50fb6c24"

export default script